//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { states, stateValueByName } from "~/src/states.js";

export default {
  props: {
    data: {
      required: true,
    },
    cta: {
      required: true,
    },
  },

  data() {
    return {
      showAllStates: false,
    };
  },

  computed: {
    getStates() {
      return states;
    },

    butterStates() {
      if (this.showAllStates) return this.data.state;
      else return this.data.state.slice(0, 8);
    },
  },
  methods: {
    getStateValue(state) {
      return "/" + stateValueByName(state);
    },
  },
};
